




























import Vue from 'vue'
import { ProgressBarWithTextInterface } from '@/config/interfaces'

export default Vue.extend({
  name: 'progressBarWithText',
  props: {
    templateItemData: {
      type: Object as () => ProgressBarWithTextInterface,
      required: true
    }
  }
})
